import { createSlice } from "@reduxjs/toolkit";

export const elasticSearchSlice = createSlice({
    name: "ElasticSearch",
    initialState: {
        totalExperience: 0,
        skills: ["default"],
        location: ["default"],
        education: ["default"],
        noticePeriod: 0,
        relocate: "default"
    },

    reducers: {
        setTotalExperience: (state, action) => {
            state.totalExperience = action.payload;
        },
        setSkills: (state, action) => {
            state.skills = action.payload;
        },
        setLocation: (state, action) => {
            state.location = action.payload;
        },
        setEducation: (state, action) => {
            state.education = action.payload;
        },
        setNoticePeriod: (state, action) => {
            state.noticePeriod = action.payload;
        },
        setRelocate: (state, action) => {
            state.relocate = action.payload;
        },

    },
});

export const { setTotalExperience, setSkills, setLocation, setEducation, setNoticePeriod, setRelocate } =
    elasticSearchSlice.actions;

export default elasticSearchSlice.reducer;
